import { TelefoneCelular } from './telefone-celular';
import { TelefoneComercial } from './telefone-comercial';
import { TelefoneResidencial } from './telefone-residencial';
import { EnderecoResidencial } from 'app/resources/classes/enderecoDeprecated';

export class CartaoDeprecated {

  public clienteId: number;
  public dataImportacao: Date;
  public dataNascimento: Date;
  public documento: string;
  public documentoInicial;
  public documentoValido: boolean;
  public emailInicial: string;
  public enderecoResidencial: EnderecoResidencial;
  public envioVirtualChave: number;
  public envioVirtualSenha: number;
  public grupos: Array<any>;
  public id: number;
  public indiceMoeda: number;
  public nome: String;
  public numero: string;
  public numeroReferencia: number;
  public produto: any;
  public SaldoDePontos: number;
  public senha: string;
  public senhaEletronica;
  public sessionToken: string;
  public sessionValidity: string;
  public sexo: string;
  public status: string;
  public telefoneCelular: TelefoneCelular;
  public telefoneComercial: TelefoneComercial;
  public telefoneResidencial: TelefoneResidencial;
  public uuid: string;
  public novaDataNascimento;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/cartaoDeprecated.ts